import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ReduxToastr, { toastr } from "react-redux-toastr";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import UAParser from "ua-parser-js";

import Meets from "app/meets/Meets";
import Meet from "app/meets/Meet";
import About from "app/about/About";
import Instructions from "app/instructions/Instructions";
import Coach from "app/coach/Coach";
import Contact from "app/contact/Contact";
import RouteNotFound from "app/RouteNotFound";
import { loadMeetsOnStartup } from "util/pouchAdapter";
import { setScreenSize } from "actions";
import { getScreenMedia } from "selectors";
import ErrorBoundary from "components/ErrorBoundary";

window.reloadRequired = function () {
  toastr.info(
    "A new version of LiftingCast is available. Please reload the page.",
    { timeOut: 300000 }
  );
};

const warnOldBrowser = () => {
  try {
    const parser = new UAParser();
    const result = parser.getResult();
    const browserName = result.browser.name;
    const browserMajorVersion = Number(result.browser.version.split(".")[0]);
    if (
      (browserName === "Safari" || browserName === "Mobile Safari") &&
      browserMajorVersion < 13
    ) {
      // alert('Your version of Safari is not supported. Please update to at least Safari version 13 to use this site.');
      console.error(
        "Your version of Safari is not supported. Please update to at least Safari version 13 to use this site."
      );
      toastr.error(
        "Your version of Safari is not supported. Please update to at least Safari version 13 to use this site.",
        { timeOut: 0 }
      );
    }
  } catch (e) {
    console.error("Failed to parse UA");
  }
};

class App extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    loadMeetsOnStartup();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    warnOldBrowser();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.props.setScreenSize(window.innerWidth);
  };

  render() {
    return (
      <div className={classNames("app", this.props.media)} id="app">
        <ErrorBoundary>
          <Helmet>
            <title>LiftingCast</title>
          </Helmet>
          <Switch>
            <Route path="/" exact component={Meets} />
            <Route path="/index.html" component={Meets} />
            <Route path="/about" exact component={About} />
            <Route path="/instructions" exact component={Instructions} />
            <Route path="/coach" exact component={Coach} />
            <Route path="/contact" exact component={Contact} />
            <Route path="/meets/" exact component={Meets} />
            <Route
              path="/meets/:meetId/platforms/:platformId"
              component={Meet}
            />
            <Route path="/meets/:meetId" component={Meet} />
            <Route component={RouteNotFound} />
          </Switch>
          <ReduxToastr />
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  media: getScreenMedia(state, props),
});
const mapDispatchToProps = {
  setScreenSize,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
